/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2024 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/

import { Component } from "react";
import { getMessage } from "utils/TranslationUtil";
import { VERB_ORGANIZE_DELETE } from "constants/enums";
import Delete from "@spectrum-icons/workflow/DeleteOutline";
import * as constants from "constants/constants";
import * as stores from "stores";
import { providers } from "dc-core";
import { handleDeletePages } from "./utils/OrganizeUtils";

class OrganizeDeleteBootstrap extends Component {
  getLabel = () => {};

  getIcon = () => Delete;

  getTooltip = () => getMessage("tooltip.delete.page");

  getAriaLabel = () => getMessage("arialabel.delete.page");

  getTooltipPlacement = () => "right";

  getTooltipDelay = () => constants.TOOLTIP_DELAY;

  id = VERB_ORGANIZE_DELETE;

  initializeAction = () => {};

  executeAction = async (opts = {}) => {
    const editProvider = await providers["edit-provider"]();
    await editProvider?.loadEditModule();
    if (opts && opts.pageIndices) {
      await handleDeletePages(stores, opts.pageIndices);
    }
  };

  render() {
    return null;
  }
}

export default OrganizeDeleteBootstrap;
